import type { FeedbackSubmission } from './ontology/types';

/** Temporary submission stub used by the feedback UI until transport is wired. */
export function submitFeedback(record: FeedbackSubmission): void {
  // TODO(2): wire transport + persistence (out of scope for T1)
  void record;
}
